// src/tools/measurement/rulerTool.js
import maplibregl from 'maplibre-gl';
import { length as turfLength } from '@turf/turf';

export const rulerTool = {
  _startDrawing: null,
  _stopDrawing: null,
  _onDrawComplete: null,
  _clearDrawing: null,
  _map: null,
  _isHandling: false, // Флаг для предотвращения рекурсии
  _popups: [], // Храним ссылки на попапы, чтобы их можно было удалить
  _focusedFeature: null, // Для измерения существующего объекта

  initialize: (map, options) => {
    console.log('Ruler tool initialized');
    rulerTool._isHandling = false;
    rulerTool._map = map;
    if (options.drawingControls) {
      rulerTool._startDrawing = options.drawingControls.startDrawing;
      rulerTool._stopDrawing = options.drawingControls.stopDrawing;
      rulerTool._onDrawComplete = options.drawingControls.onDrawComplete;
      rulerTool._clearDrawing = options.drawingControls.clearDrawing;
    }
    rulerTool._focusedFeature = options.focusedFeature;
  },
  activate: () => {
    console.log('Ruler tool activated');
    rulerTool._isHandling = false; // Сбрасываем флаг при активации

    // Если инструмент активирован во время редактирования объекта, измеряем его
    if (rulerTool._focusedFeature && rulerTool._focusedFeature.geometry.type === 'LineString') {
        rulerTool.handleDrawComplete(rulerTool._focusedFeature);
        rulerTool._stopDrawing?.(); // Останавливаем любой активный режим рисования
        // Не запускаем режим рисования
        return;
    }

    // Устанавливаем обработчик завершения рисования
    rulerTool._onDrawComplete?.(rulerTool.handleDrawComplete);
    // Линейка измеряет линии
    rulerTool._startDrawing?.('line');
  },
  deactivate: () => {
    console.log('Ruler tool deactivated');
    // Сбрасываем обработчик
    rulerTool.cleanup();
    rulerTool._onDrawComplete?.(null);
    rulerTool._stopDrawing?.();
    rulerTool._focusedFeature = null;
  },
  cleanup: () => {
    // Копируем массив, чтобы избежать рекурсивного вызова при удалении.
    const popupsToRemove = [...rulerTool._popups];
    rulerTool._popups = [];
    popupsToRemove.forEach(p => p.remove());
  },
  handleDrawComplete: (feature) => {
    if (rulerTool._isHandling) return;
    rulerTool._isHandling = true;

    // Если это существующий объект, не выходим из режима рисования
    const isExistingFeature = !!rulerTool._focusedFeature;
    if (!isExistingFeature) rulerTool._stopDrawing?.();

    const coords = feature.geometry.coordinates;
    if (coords.length < 2) return;

    let totalLength = 0;

    // Создаем попапы для каждого сегмента
    for (let i = 0; i < coords.length - 1; i++) {
      const p1 = coords[i];
      const p2 = coords[i+1];
      const segment = { type: 'LineString', coordinates: [p1, p2] };
      const segmentLength = turfLength(segment, { units: 'meters' });
      totalLength += segmentLength;

      // Вычисляем середину сегмента для попапа
      const midPoint = [(p1[0] + p2[0]) / 2, (p1[1] + p2[1]) / 2];

      const popup = new maplibregl.Popup({
        closeButton: false,
        closeOnClick: false,
        anchor: 'bottom',
      })
      .setLngLat(midPoint)
      .setHTML(`<div style="background: white; padding: 2px 5px; border-radius: 4px; font-size: 12px;">${segmentLength.toFixed(1)} м</div>`)
      .addTo(rulerTool._map);
      rulerTool._popups.push(popup);
    }

    // Создаем попап для общей длины в конце линии
    const lastPoint = coords[coords.length - 1];
    const totalPopup = new maplibregl.Popup({
      closeButton: true,
      closeOnClick: false,
      anchor: 'left',
    })
    .setLngLat(lastPoint)
    .setHTML(`<div style="background: #333; color: white; padding: 5px 10px; border-radius: 4px; font-size: 14px;"><b>Общая длина:</b><br>${totalLength.toFixed(1)} м</div>`)
    .addTo(rulerTool._map);
    rulerTool._popups.push(totalPopup);

    // Добавляем обработчик на закрытие главного попапа
    totalPopup.on('close', () => {
        rulerTool.cleanup(); // Удаляем все попапы
        // Если это было измерение нового объекта (не из режима редактирования), очищаем и перезапускаем
        if (!isExistingFeature) {
            rulerTool._clearDrawing?.(); // Удаляем нарисованную геометрию
            rulerTool._isHandling = false;
            rulerTool._startDrawing?.('line');
        } else {
            // Если измеряли существующий, просто сбрасываем флаг
            rulerTool._isHandling = false;
        }
    });
  }
};